<script>
import {useFirmwareTypesStore} from "@/stores/firmwareTypes.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterFirmwareTypesTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useFirmwareTypesStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.firmwareTypesStore.indexFirmwareTypeOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">Firmware Types</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="firmwareType in firmwareTypesStore.getFirmwareTypeOptions"
        v-bind="$attrs"
        :value="firmwareType.id"
        :label="firmwareType.name"
    />
  </div>
</template>

<style scoped>

</style>